import CommentIcon from '@atlaskit/icon/core/comment';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import { getValueId } from '@databases/utils/utils';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { type SelectionsEffectMenuItemBuilder } from '../types';

export const commentsMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  _actions,
  skip
) => {
  if (!context.capabilities.canOpenComments) {
    return skip;
  }

  return (_, setOpenThread) => ({
    key: SELECT_VALUE_MENU_ACTIONS.COMMENTS,
    content: context.formatMessage(messages['value-actions.comments']),
    onClick: () => {
      const valueId = getValueId(context.entryId, context.fieldId);

      setOpenThread({ valueId, create: true, panel: context.panel });

      context.closeMenu();
    },
    tooltipPosition: 'right',
    elemBefore: <CommentIcon label="" />,
    elemAfter: <>{tooltip(SHORTCUTS.OPEN_COMMENTS.keyMap)}</>,
    keyboardShortcut: SHORTCUTS.OPEN_COMMENTS.keyboardShortCut
  });
};
